export const IS_SIGN_IN = "IS_SIGN_IN";
export const USER_USERNAME = "USER_USERNAME"
export const USER_EMAIL = "USER_EMAIL"
export const USER_PASSWORD = "USER_PASSWORD"
export const USER_FULLNAME = "USER_FULLNAME"
export const USER_ID = "USER_ID"